import { defineStore } from 'pinia'
import CartService from '@/services/cart-service'
import { Cart, ConfigItem, ContractPriceItem, WebsiteItem } from '@/types'
import { toRaw } from 'vue'

interface CartState {
    cart: Cart | null
    cartItemUpdating: boolean
    cartClearing: boolean
    editingRowIndex: string
}

export const useCartStore = defineStore('cart', {
    state: (): CartState => {
        return {
            cart: null,
            cartItemUpdating: false,
            cartClearing: false,
            editingRowIndex: '',
        }
    },

    actions: {
        async get () {
            try {
                this.cart = await CartService.get()
            } catch(err) {
                console.log(err)
            }
        },

        async addItem (item: ConfigItem|WebsiteItem|ContractPriceItem, quantity = 1) {
            try {
                this.cart = await CartService.addItem(item, quantity)
            } catch (err) {
                console.log(err)
            }
        },

        async updateQuantity (newQuantity: number, item: ConfigItem|WebsiteItem|ContractPriceItem, useBroken: boolean) {
            try {
                const currentItem = toRaw(item)

                if (!!(currentItem as ContractPriceItem).contractPrice) {
                    (currentItem as ContractPriceItem).unitPrice = useBroken ?
                        (currentItem as ContractPriceItem).contractPrice.brokenPrice || 0 :
                        (currentItem as ContractPriceItem).contractPrice.fullPrice || 0
                }

                this.cart = await CartService.updateQuantity(currentItem, newQuantity)
            } catch (err) {
                console.log(err)
                throw err
            }
        },

        async removeItem (item: ConfigItem|WebsiteItem|ContractPriceItem) {
            try {
                this.cart = await CartService.removeItem(item)
            } catch (err) {
                console.log(err)
                throw err
            }
        },

        async clear () {
            try {
                this.cart = await CartService.clear()
            } catch (err) {
                console.log(err)
                throw err
            }
        },

        updateCart(cart: Cart) {
            this.cart = cart
        },

        toggleCartItemUpdating() {
            this.cartItemUpdating = !this.cartItemUpdating
        },

        toggleCartClearing() {
            this.cartClearing = !this.cartClearing
        },

        setEditingRowIndex(editingRowIndex: string) {
            this.editingRowIndex = editingRowIndex
        },
    },
})
